module.exports = __webpack_public_path__ + "img/c06_unitsapper_Normal_ua.f4c9fdf0.webp";